// client/src/services/adminApi.js
import axios from "axios";
import { REACT_APP_SERVER_URL } from "../constants/adminConstants";

axios.defaults.withCredentials = true;

// Generic API call function
export const apiCall = async (method, url, data = null) => {
  try {
    const config = { withCredentials: true };
    const response = await (method === "GET"
      ? axios.get(url, config)
      : method === "POST"
      ? axios.post(url, data, config)
      : method === "PUT"
      ? axios.put(url, data, config)
      : axios.delete(url, config));
    return response;
  } catch ({ response }) {
    return response;
  }
};

// User API functions
export const addUser = async (userData) => {
  return await apiCall("POST", `${REACT_APP_SERVER_URL}/users`, userData);
};

export const updateUser = async (id, userData) => {
  return await apiCall("PUT", `${REACT_APP_SERVER_URL}/users/${id}`, userData);
};

export const deleteUser = async (id) => {
  return await apiCall("DELETE", `${REACT_APP_SERVER_URL}/users/${id}`);
};

// Tentative API functions
export const deleteTentative = async (id) => {
  return await apiCall("DELETE", `${REACT_APP_SERVER_URL}/tentatives/${id}`);
};

export const approveTentative = async (id, userData) => {
  // First create the user
  const userResponse = await apiCall(
    "POST",
    `${REACT_APP_SERVER_URL}/users`,
    userData
  );
  if (userResponse.status === 200) {
    // Then delete the tentative
    return await apiCall("DELETE", `${REACT_APP_SERVER_URL}/tentatives/${id}`);
  }
  return userResponse;
};

